import {
  CreateTimeFrameRangeBulkInput,
  CreateTimeFrameRangeBulkResponse,
  CreateTimeFrameRangeInput,
  TimeFrameRange,
} from '@/models/gen/graphql';
import { Datetime, Validation } from '@/utils';

import { CreateTimeFrameRangeBulkDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import graphApi from '@/api';

type CreateTimeFrameRangeBulkGraphApiResponse = GraphApiResponse<typeof CreateTimeFrameRangeBulkDocument>;

export const createTimeFrameRangeValidator = new Validation.Validator({
  'timeFrameId!': (val: any): Validation.Validity => ({
    valid: Validation.isValidUUID(val),
  }),
  'name!': (val: any): Validation.Validity => ({
    valid: !!val && new RegExp('^[^ ][0-9a-z ]', 'i').test(val),
  }),
  'startTime!': (val: any): Validation.Validity => ({
    valid: Validation.isTimeString(val),
  }),
  'endTime!': (val: any): Validation.Validity => ({
    // in code lets ensure start time is before end time
    valid: Validation.isTimeString(val),
  }),
});

const createTimeFrameRangeBulkResponseSelector = (res: CreateTimeFrameRangeBulkGraphApiResponse): CreateTimeFrameRangeBulkResponse =>
  !res.errors ? (res?.createTimeFrameRangeBulk as CreateTimeFrameRangeBulkResponse) : undefined;

const [runCreateTimeFrameRangeBulk] = graphApi(CreateTimeFrameRangeBulkDocument);

const createTimeFrameRangeBulk = async (timeFrameRanges: Partial<TimeFrameRange>[]): Promise<CreateTimeFrameRangeBulkResponse> => {
  const values: CreateTimeFrameRangeInput[] = timeFrameRanges.map((timeFrameRange: TimeFrameRange): CreateTimeFrameRangeInput => {
    const startDatetime = new Datetime().setTime(timeFrameRange.startTime);
    const endDatetime = new Datetime().setTime(timeFrameRange.endTime);
    if (startDatetime.isAfter(endDatetime.toString())) throw new Error('Start time must be before end time');
    return createTimeFrameRangeValidator.create(timeFrameRange);
  });
  const input: CreateTimeFrameRangeBulkInput = { values };

  const res = await runCreateTimeFrameRangeBulk({ input });
  return createTimeFrameRangeBulkResponseSelector(res);
};

export default createTimeFrameRangeBulk;
